export enum EExternalLinkType {
  email = "email",
  phone = "phone",
  url = "url"
}

export type TExternalLink = {
  type: EExternalLinkType;
  value: string;
  originalText?: string; // The original text as it appears in the message
}